import {SalesLeagueRow} from '@dms/api/sales';

export const getSalesLeagueRepName = (row: Pick<SalesLeagueRow, 'firstName' | 'lastName'>) =>
  `${row.firstName} ${row.lastName}`;
